<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="安置名称">
                  <el-input style="width: 186px" v-model="queryForm.placeName"></el-input>
              </el-form-item>
              <el-form-item label="安置类型">
                  <!-- <el-input style="width: 186px" v-model="queryForm.placeType"></el-input> -->
                  <el-select
                    size="small"
                    style="width: 186px"
                    v-model="queryForm.placeType"
                  >
                    <el-option
                      v-for="item in auditStatus"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否激活">
                  <!-- <el-input style="width: 186px" v-model="queryForm.isActive"></el-input> -->
                  <el-select
                        style="width: 186px;"
                        v-model="queryForm.isActive"
                        size="small"
                        placeholder="请选择"
                    >
                        <el-option
                            label="是"
                            :value="1"
                        ></el-option>
                        <el-option
                            label="否"
                            :value="0"
                        ></el-option>
                    </el-select>
              </el-form-item>
              <el-form-item label="字典类型">
                  <el-input style="width: 186px" v-model="queryForm.dictType"></el-input>
              </el-form-item>
              <el-form-item label="安置介绍">
                  <el-input style="width: 186px" v-model="queryForm.placeIntro"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelPlaceList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelPlace"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelPlace(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelPlace(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshModelPlaceList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelPlaceList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="placeName"
        label="安置名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="placeType"
        label="安置类型"
        min-width="180"
      > 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isActive"
        label="是否激活"
        min-width="180"
      >
        <template slot-scope="scope">
          {{ scope.row.isActive == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dictType"
        label="字典类型"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="placeIntro"
        label="安置介绍"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
            <div @click="checkModelPlace(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editModelPlace(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelPlace(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelPlaceStates[modelPlaceState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelPlace"
          ref="modelPlaceForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <!-- <el-form-item
            label="安置名称"
            prop="placeName"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="modelPlace.placeName"
              :disabled="modelPlaceState == 'check'"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="安置名称"
            prop="placeType"
          >
            <!-- <el-input
              size="small"
              v-model="modelPlace.placeType"
              :disabled="modelPlaceState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="modelPlace.placeType"
              :disabled="modelPlaceState == 'check'"
            >
              <el-option
                v-for="item in auditStatus"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否激活"
            prop="isActive"
          >
            <!-- <el-input
              size="small"
              v-model="modelPlace.isActive"
              :disabled="modelPlaceState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 186px;"
                v-model="modelPlace.isActive"
                size="small"
                placeholder="请选择"
                :disabled="modelPlaceState == 'check'"
            >
                <el-option
                    label="是"
                    :value="1"
                ></el-option>
                <el-option
                    label="否"
                    :value="0"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="字典类型"
            prop="dictType"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="modelPlace.dictType"
              :disabled="modelPlaceState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="安置介绍"
            prop="placeIntro"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="modelPlace.placeIntro"
              :disabled="modelPlaceState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelPlaceState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlace.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelPlaceList();
                    this.getModelPlaceList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelPlaceList();
                    this.getModelPlaceList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     placeName: '', //安置名称
                     placeType: '', //安置类型
                     isActive: '', //是否激活
                     dictType: '', //字典类型
                     placeIntro: '', //安置介绍
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelPlaceState: 'add',
                modelPlaceStates: {
                    add: '新建安置',
                    check: '查看安置',
                    edit: '修改安置'
                },

                multipleSelection: [],
                modelPlaceList: [],
                modelPlace: {
                    id: '', //ID
                    placeName: '', //安置名称
                    placeType: '', //安置类型
                    isActive: '', //是否激活
                    dictType: '', //字典类型
                    placeIntro: '', //安置介绍
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    placeName: [{ required: true, message: '安置名称不能为空', trigger: 'blur' }],
                    placeType: [{ required: true, message: '安置类型不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    // dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    placeIntro: [{ required: true, message: '安置介绍不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                auditStatus:[],
            };
        },
        created() {
            this.getModelPlaceList();
            this.getAuditStatus();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getAuditStatus() {
                get('/mpp/utils/getEnum', { enumType: 'model_place_type' }).then((res) => {
                    this.auditStatus = res.enumList;
                });
            },
            computeAuditStatus(type){
                for (let i = 0; i < this.auditStatus.length; i++) {
                    if(this.auditStatus[i].key == type){
                        return this.auditStatus[i].value
                    }
                }
            },
            resetModelPlaceList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelPlaceList = [];
            },
            resetDialog() {
                this.modelPlaceState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      placeName: '', //安置名称
                      placeType: '', //安置类型
                      isActive: '', //是否激活
                      dictType: '', //字典类型
                      placeIntro: '', //安置介绍
                };
                this.getModelPlaceList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelPlace = {
                      id: '', //ID
                      placeName: '', //安置名称
                      placeType: '', //安置类型
                      isActive: '', //是否激活
                      dictType: '', //字典类型
                      placeIntro: '', //安置介绍
                };
            },
            submitForm() {
                if (this.modelPlaceState == 'add') {
                    this.$refs.modelPlaceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/place/add`,{ ...this.modelPlace }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelPlaceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelPlaceState == 'edit') {
                    this.$refs.modelPlaceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/place/edit`,{ ...this.modelPlace }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelPlaceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelPlace() {
                this.showDialog = true;
                this.modelPlaceState = 'add';
            },
            checkModelPlace(modelPlaceId) {
                console.log(modelPlaceId);
                this.currentModelPlaceId = modelPlaceId;

                this.getModelPlaceById();
                this.showDialog = true;
                this.modelPlaceState = 'check';
            },
            editModelPlace(modelPlaceId) {
                console.log('modelPlace', modelPlaceId);
                if (modelPlaceId) {
                    this.currentModelPlaceId = modelPlaceId;
                    this.getModelPlaceById();
                } else {
                    this.modelPlace = { ...this.modelPlace, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelPlaceState = 'edit';
            },
            deleteModelPlace(modelPlaceId) {
                let ids = '';
                if (modelPlaceId) {
                    ids = modelPlaceId;
                } else {
                    ids = this.multipleSelection.map((modelPlace) => modelPlace.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/place/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelPlaceList();
                                this.getModelPlaceList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelPlaceList() {
                this.resetModelPlaceList();
                this.getModelPlaceList();
            },
            getModelPlaceList(query = {}) {
                this.loading = true;
                get(`/model/place/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelPlaceList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelPlaceById() {
                get(`/model/place/get`,{ id: this.currentModelPlaceId }).then((res) =>{
                    if(res.success){
                      this.modelPlace = { ...this.modelPlace, ...res.modelPlace };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelPlaceList() {
                //this.btnLoading = true;
                exprotExcel(`/model/place/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/place/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/place/importData`,formData);
              this.refreshModelPlaceList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelPlaceList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelPlaceList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>